import {CONSTANTS} from '@app/constants';
import axios from 'axios';

const apiService = axios.create({
  baseURL: CONSTANTS.API_URL,
  withCredentials: false,
  timeout: 20000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default apiService;
